import OverviewValues from '@client/models/store/user/overviewValues';
import Current from '@client/models/store/user/current';
import {Constants} from '@client/util/constants';

export default class User {
  // eslint-disable-next-line max-statements
  constructor() {
    this.current = new Current();
    this.hasChanged = false;
    this.segmentId = null;
    this.custodianId = null;
    this.custodianName = null;
    this.mailingAddress = null;
    this.investmentProfile = null;
    this.overviewValues = new OverviewValues();
    this.accountSettings = [];

    this.id = null;
    this.accessToken = null;
    this.expiresIn = null;
    this.refreshToken = null;
    this.riaId = null;
    this.scope = null;
    this.tokenType = null;
    this.type = null;

    this.emailVerified = null;
    this.aggregatedAccounts = [];
    this.accountAdditionalHeaderInfo = [];
    this.totalLiability = 0;
    this.totalAssets = 0;
    this.userCustodianList = [];
    this.segment = null;
    this.portfolioType = null;
  }

  // eslint-disable-next-line max-lines-per-function
  static userToPayload(state) {
    const updatedContactInfo = {
      address1: state.current.address1
        ? state.current.address1
            .replace(/ +(?= )/g, '')
            .trim()
            .toUpperCase()
        : state.current.address1,
      address2: state.current.address2
        ? state.current.address2
            .replace(/ +(?= )/g, '')
            .trim()
            .toUpperCase()
        : state.current.address2,
      city: state.current.city
        ? state.current.city
            .replace(/ +(?= )/g, '')
            .trim()
            .toUpperCase()
        : state.current.city,
      state: state.current.state
        ? state.current.state
            .replace(/ +(?= )/g, '')
            .trim()
            .toUpperCase()
        : state.current.state,
      zip: state.current.zip
        ? state.current.zip
            .replace(/ +(?= )/g, '')
            .trim()
            .toUpperCase()
        : state.current.zip,
    };
    let updatedMailing = {
      address1: state.mailingAddress.street_address,
      address2: state.mailingAddress.address2,
      city: state.mailingAddress.city,
      state: state.mailingAddress.state,
      zip: state.mailingAddress.zipcode,
    };

    if (state.current.sameMailing) {
      updatedMailing = {
        address1: state.current.address1,
        address2: state.current.address2,
        city: state.current.city,
        state: state.current.state,
        zip: state.current.zip,
      };
    }

    Object.entries(updatedMailing).forEach(([k, v]) => {
      if (v) {
        updatedMailing[k] = v
          .replace(/ +(?= )/g, '')
          .trim()
          .toUpperCase();
      }
    });
    const isMailingSame = JSON.stringify(updatedContactInfo) === JSON.stringify(updatedMailing);

    // eslint-disable-next-line no-param-reassign
    state.current.sameMailing = isMailingSame;

    return {
      ...updatedContactInfo,
      ...this.mailingToAddress(updatedMailing),
      country: Constants.DEFAULT_COUNTRY,
      phone1: state.current.primary_phone,
      email: state.current.primary_email,
      flag: 1,
      mailingActive: isMailingSame ? '0' : '1',
    };
  }

  static mailingToAddress(mailing) {
    return {
      mailingAddress1: mailing.address1,
      mailingAddress2: mailing.address2,
      mailingCity: mailing.city,
      mailingState: mailing.state,
      mailingZip: mailing.zip,
    };
  }
}
